export const ORDER_STATUSES = [
  'NEW',
  'PAID',
  'IN_PRODUCTION',
  'PRINTED',
  'IN_DELIVERY',
  'DELIVERED',
  'RETURNED',
  'CANCELLED',
] as const;

export type OrderStatus = typeof ORDER_STATUSES[number];

export const ORDER_ITEM_STATUSES = [
  'NEW',
  'IN_ORDER',
  'FIRST_ORDER',
  'SECOND_ORDER',
  'PAID',
  'REUPLOAD_IMAGE',
  'REUPLOADED',
  'READY_TO_PRINT',
  'PRINTED',
  'IN_DELIVERY',
  'DELIVERED',
  'RETURNED',
  'CANCELLED',
] as const;

export type OrderItemStatus = typeof ORDER_ITEM_STATUSES[number];

export const ORDER_FLOW_ITEM_STATUSES: readonly OrderItemStatus[] = [
  'IN_ORDER',
  'FIRST_ORDER',
  'SECOND_ORDER',
  'PAID',
  'REUPLOAD_IMAGE',
  'REUPLOADED',
  'READY_TO_PRINT',
  'PRINTED',
  'IN_DELIVERY',
  'DELIVERED',
] as const;

export const ORDER_FLOW_ITEM_STATUS_SET: ReadonlySet<OrderItemStatus> = new Set(ORDER_FLOW_ITEM_STATUSES);

export const isOrderFlowItemStatus = (value: unknown): value is OrderItemStatus =>
  typeof value === 'string' && ORDER_FLOW_ITEM_STATUS_SET.has(value as OrderItemStatus);
